



<h1 *ngIf="header">{{globals.getLocalizedValue(header)}} "{{searchParam}}"</h1>

<!--<div class="row">
    <div class="col s12">
        <ul class="tabs card tabs-fixed-width" materialize="tabs">
            <li class="tab col s3">
                <a class="active" href="#" (click)="setType('COURSE_UNIT')">
                    <span *ngIf="course">{{globals.getLocalizedValue(course)}}</span>
                </a>
            </li>
            <li class="tab col s3">
                <a href="#" (click)="setType('STUDY_MODULE')">
                    <span *ngIf="studyModule">{{globals.getLocalizedValue(studyModule)}}</span>
                </a>
            </li>
            <li class="tab col s3">
                <a *ngIf="programme" href="#" (click)="setType('PROGRAMME')">
                    <span *ngIf="programme">{{globals.getLocalizedValue(programme)}}</span>
                </a>
            </li>
        </ul>
    </div>
</div>-->




<mat-tab-group (selectedTabChange)="test($event)" dynamicHeight mat-stretch-tabs mat-align-tabs="center">
    <mat-tab label="{{globals.getLocalizedValue(course)}}">
    <!--<mat-tab label="{{globals.getLocalizedValue(course)}}"> -->


      <!-- <mat-spinner *ngIf="!isLoaded"></mat-spinner>-->

        


    </mat-tab>

    <!--<ng-template mat-tab-label>
        <span (selectedTabChange)="setType('STUDY_MODULE')">{{globals.getLocalizedValue(studyModule)}}</span>
    </ng-template>-->
    <mat-tab label="{{globals.getLocalizedValue(studyModule)}}"> 
    

   <!-- <mat-spinner *ngIf="!isLoaded"></mat-spinner>
    <div *ngIf="isLoaded">

    <table class="striped" *ngIf="result && result?.learningUnits && result?.learningUnits.length > 0">
        <thead>
            <tr>
                <th *ngIf="code">{{globals.getLocalizedValue(code)}}</th>
                <th *ngIf="name">{{globals.getLocalizedValue(name)}}</th>

            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let unit of result.learningUnits">
                <td *ngIf="!period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}" >{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{unit.code}}</a>
                </td>
                <td *ngIf="period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                </td>
                <td *ngIf="!period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                </td>
                <td *ngIf="period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}" >{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                </td>

            </tr>
        </tbody>
    </table>

    </div>
    <div *ngIf="result && !result?.learningUnits || result?.learningUnits.length == 0">
        <span *ngIf="notFound">{{globals.getLocalizedValue(notFound)}}</span>
    </div>-->
</mat-tab>

   <!-- <ng-template mat-tab-label>
        <span (selectedTabChange)="setType('PROGRAMME')">{{globals.getLocalizedValue(studyModule)}}</span>
    </ng-template>-->
    <mat-tab label="{{globals.getLocalizedValue(programme)}}"> 
    

   <!-- <mat-spinner *ngIf="!isLoaded"></mat-spinner>
    <div *ngIf="isLoaded">

    <table class="striped" *ngIf="result && result?.learningUnits && result?.learningUnits.length > 0">
        <thead>
            <tr>
                <th *ngIf="code">{{globals.getLocalizedValue(code)}}</th>
                <th *ngIf="name">{{globals.getLocalizedValue(name)}}</th>

            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let unit of result.learningUnits">
                <td *ngIf="!period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}" >{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{unit.code}}</a>
                </td>
                <td *ngIf="period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                </td>
                <td *ngIf="!period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                </td>
                <td *ngIf="period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}" >{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                </td>

            </tr>
        </tbody>
    </table>

    </div>
    <div *ngIf="result && !result?.learningUnits || result?.learningUnits.length == 0">
        <span *ngIf="notFound">{{globals.getLocalizedValue(notFound)}}</span>
    </div>-->
</mat-tab>
</mat-tab-group>

<mat-spinner *ngIf="!isLoaded"></mat-spinner>

<div *ngIf="isLoaded" >
    <table class="striped" *ngIf="result && result?.learningUnits && result?.learningUnits.length > 0">
        <thead>
            <tr>
                <th *ngIf="code">{{globals.getLocalizedValue(code)}}</th>
                <th *ngIf="name">{{globals.getLocalizedValue(name)}}</th>

            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let unit of result.learningUnits">
                <td *ngIf="!period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}" >{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{unit.code}}</a>
                </td>
                <td *ngIf="period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{unit.code}}</a>
                </td>
                <td *ngIf="!period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                </td>
                <td *ngIf="period">
                    <a *ngIf="unit?.type === 'STUDY_MODULE'" routerLink="/{{globals.lang}}/{{globals.getLocalizedStudyModule()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}" >{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'OFFERING'" routerLink="/{{globals.lang}}/{{globals.getLocalizedOffering()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'PROGRAMME'" routerLink="/{{globals.lang}}/{{globals.getDegreeProgramme()}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                    <a *ngIf="unit?.type === 'COURSE_UNIT'" routerLink="/{{globals.lang}}/{{globals.getLocalizedCourse()}}/{{unit?.code}}/{{unit?.learningUnitId}}" [queryParams]="{period: period}">{{globals.getLocalizedValueForTitle(unit.name)}}</a>
                </td>

            </tr>
        </tbody>
    </table>

    </div>

    <div *ngIf="result && !result?.learningUnits || result?.learningUnits.length == 0">
        <span *ngIf="notFound">{{globals.getLocalizedValue(notFound)}}</span>
    </div>